import { useDispatch } from "react-redux";
import { useI18N } from "@src/language/language-context";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";
import { updateShowOtaInstallationInProgressModal } from "@src/reducers/your-reducer";
import { OTA_OBJECT_TYPE } from "@src/cloud-connect/ota-update/constants";
interface UseOtaFirmwareInstallationInProgressProps {
  activeInstallationData?: ActiveInstallationProcessPayload | null;
}

export const useOtaFirmwareInstallationInProgress = ({
  activeInstallationData,
}: UseOtaFirmwareInstallationInProgressProps) => {
  const dispatch = useDispatch();
  const i18n = useI18N();

  const isBackupInstallation =
    activeInstallationData?.firmware?.type === OTA_OBJECT_TYPE.FIRMWARE_BACKUP;
  const installationName = activeInstallationData?.firmware?.filename || "";
  const installationId =
    activeInstallationData?.update_details?.sftp_push_operation_id;
  const normalizedInstallationId = String(installationId ?? "").trim();

  const titleTemplate = isBackupInstallation
    ? i18n("modules.otaFirmwareInstallationInProgress.titleTemplateBackup")
    : i18n("modules.otaFirmwareInstallationInProgress.titleTemplateFirmware");

  const installationIdTemplate = i18n(
    "modules.otaFirmwareInstallationInProgress.installationIdTemplate",
  );

  const hasInstallationId = Boolean(normalizedInstallationId);

  const installationIdText = hasInstallationId
    ? installationIdTemplate.replace("{ID}", normalizedInstallationId)
    : "";

  const title = titleTemplate
    .replace("{itemName}", installationName)
    .replace("{installationId}", installationIdText);

  const itemNameMarker = "__ITEM_NAME__";
  const titleTemplateWithMarker = titleTemplate.replace(
    "{itemName}",
    itemNameMarker,
  );
  const [titlePrefixRaw, titleSuffixRaw = ""] =
    titleTemplateWithMarker.split(itemNameMarker);

  const texts = {
    title,
    titleHasItemName: titleTemplate.includes("{itemName}"),
    titlePrefix: titlePrefixRaw.replace("{installationId}", installationIdText),
    titleSuffix: titleSuffixRaw.replace("{installationId}", installationIdText),
    itemName: installationName,
    description: isBackupInstallation
      ? i18n("modules.otaFirmwareInstallationInProgress.descriptionBackup")
      : i18n("modules.otaFirmwareInstallationInProgress.descriptionFirmware"),
    showDetailsButtonText: i18n(
      "modules.otaFirmwareInstallationInProgress.showDetailsButtonText",
    ),
  };

  const handleShowDetails = () => {
    dispatch(updateShowOtaInstallationInProgressModal(true));
  };

  return {
    texts,
    handleShowDetails,
  };
};
